import React, { useState, useEffect, useContext, useRef } from 'react';
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import styles from '../styles/loginPage.js';
import loginBg from "assets/img/driver1.jpg";
import loginLogo from "assets/img/logo192x192.png";
import { useSelector, useDispatch } from "react-redux";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AlertDialog from '../components/AlertDialog';
import CountrySelect from '../components/CountrySelect';
import { FirebaseContext, api } from 'common';
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import { useGoogleLogin } from '@react-oauth/google';
import { colors } from 'components/Theme/WebTheme.js';
import { Typography } from "@mui/material";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AppleIcon from '@mui/icons-material/Apple';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PublicIcon from '@mui/icons-material/Public';
import { useParams } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  const { refer } = useParams();
  const { authRef, RecaptchaVerifier, signInWithPhoneNumber } = useContext(FirebaseContext);
  const { t } = useTranslation();
  const {
    googleLogin,
    clearLoginError,
    mobileSignIn,
    countries,
    sendResetMail,
    verifyEmailPassword,
    requestMobileOtp,
    verifyMobileOtp,
    mainSignUp,
    checkUserExists,
    validateReferer,
    validateCityCodeClient,
    fetchZonificacionCities,
    networkSignupErrorMessage,
    normalizeSignupCode,
    looksLikeCityZoningCode,
    CUSTOMER_CITIES,
    customerCityLabel,
    isCityOperationalForDrivers,
  } = api;
  const signupError = (code) => networkSignupErrorMessage(code, t, 'reg_error');
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const zonificacionCities = useSelector(state => state.zonificacion?.cities);
  const dispatch = useDispatch();
  const [capatchaReady, setCapatchaReady] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [verifier, setVerifier] = useState(null);
  const [mobileWithoutCountry, setMobileWithoutCountry] = useState('');
  const[showSignUp, setShowSignUp] = useState(false);
  const [message,setMessage] = useState(false)
  const [cityComingSoon, setCityComingSoon] = useState(false)
  const [showPassword, setShowPassword] = useState(true)
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);
  const forgotBusyRef = useRef(false);

  const [data, setData] = React.useState({
    email: '',
    confirmpassword: "",
    country: "",
    contact: '',
    mobile:"",
    password: '',
    otp: '',
    verificationId: null,
    firstName: '',
    lastName: '',
    selectedcountry:null,
    usertype:'customer',
    referralId:'',
    cityId: '',
    cityName: '',
    entryType: null
  });

  const [otpCalled, setOtpCalled] = useState();

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });

  const classes = useStyles();
  const { ...rest } = props;

  useEffect(() => {
    if(settings){
        for (let i = 0; i < countries.length; i++) {
            if(countries[i].label === settings.country){
                setData((prev) => ({
                  ...prev,
                  country: countries[i].phone,
                  selectedcountry:countries[i],
                }));
            }
        }
    }
  }, [settings,countries]);

  useEffect(() => {
    dispatch(fetchZonificacionCities());
  }, [dispatch, fetchZonificacionCities]);

  const isDriverSignup = data.usertype === 'driver';
  const driverCities = (zonificacionCities || []).filter((c) => c.active !== false);
  const customerCities = Array.isArray(CUSTOMER_CITIES) ? CUSTOMER_CITIES : [];
  const citiesForRole = isDriverSignup ? driverCities : customerCities;
  const selectedCity = citiesForRole.find((c) => c.id === data.cityId);
  const citySlotsFull = !!(
    isDriverSignup &&
    selectedCity &&
    ((selectedCity.slotsUsed || 0) >= (selectedCity.slotsTotal || 100) || selectedCity.slotsFull)
  );

  useEffect(() => {
    if(!window.recaptchaVerifier){
      setCapatchaReady(true);
    }
    if (auth.profile) {
      if(auth.profile.uid){
        let role = auth.profile.usertype;
        if(role==='admin' || role==='fleetadmin'){
          navigate('/dashboard');
        }
        else if (role==='driver'){
          navigate('/bookings');
        }
        else {
          navigate('/');
        }
      }
    }
    if (auth.error && auth.error.flag && auth.error.msg.message !== t('not_logged_in')) {
      if (auth.error.msg.message === t('require_approval')){
        setCommonAlert({ open: true, msg: t('require_approval') })
      } else if(auth.error.msg.message === "Firebase: Error (auth/invalid-verification-code)."){
        setCommonAlert({ open: true, msg: t('login_error') })
        setIsLoading(false);
      } else{
        if(data.contact && (data.contact === '' ||  !(!data.contact))){
          setCommonAlert({ open: true, msg: t('login_error') })
          setIsLoading(false);
        }
      }
    }
    if(auth.verificationId && otpCalled){
      setOtpCalled(false);
      setData({ ...data, verificationId: auth.verificationId });
    }
  }, [auth.profile, auth.error, auth.verificationId, navigate, data, data.email, data.contact, capatchaReady,RecaptchaVerifier,t, setData, otpCalled, setOtpCalled]);


  const loginWithGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      if (tokenResponse?.access_token) {
        setIsLoading(true);
        dispatch(googleLogin(null, tokenResponse.access_token));
      } else {
        setCommonAlert({ open: true, msg: t('login_error') });
        setIsLoading(false);
      }
    },
    onError: () => {
      setCommonAlert({ open: true, msg: t('login_error') });
      setIsLoading(false);
    },
  });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' });
    if (auth.error.flag) {
      setData({...data,email:'',pass:''});
      dispatch(clearLoginError());
    }
  };

  const onInputChange = (event) => {
    const { id, value } = event.target;
    setData((prev) => ({ ...prev, [id]: value }))
  }

  const handleGetOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if(data.country){
      if(data.contact){
        if (isNaN(data.contact)) {
          setData({...data, entryType: 'email'});
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if(re.test(data.contact)){
            await dispatch(verifyEmailPassword(
              data.contact,
              data.otp
            ));
          }else{
              setCommonAlert({ open: true, msg: t('proper_email')})
              setIsLoading(false);
          }
        } else{
          setData({...data, entryType: 'mobile'});
          if(settings.AllowCriticalEditsAdmin){
          let formattedNum = data.contact.replace(/ /g, '');
          const phoneNumber = "+" + data.country + formattedNum;
          if (formattedNum.length > 6) {
            if(settings.customMobileOTP){
              dispatch(requestMobileOtp(phoneNumber));
              setData({...data, verificationId: true})
              setIsLoading(false)
            } else {
              if(!window.recaptchaVerifier || verifier===null){
                window.recaptchaVerifier = await new RecaptchaVerifier(authRef(),'sign-in-button', {
                  'size': 'invisible',
                  'callback': function(response) {
                    setCapatchaReady(true);
                  }
                });
              }
              const appVerifier = window.recaptchaVerifier;
              setVerifier(appVerifier);
              await signInWithPhoneNumber(authRef(), phoneNumber, appVerifier)
                .then(res => {
                    setData({...data, verificationId: res.verificationId})
                    setIsLoading(false)
                    window.recaptchaVerifier.clear();
                })
                .catch(error => {
                    setCommonAlert({ open: true, msg: error.code + ": " + error.message});
                    setIsLoading(false);
              });
            }
          } else {
              setCommonAlert({ open: true, msg: t('mobile_no_blank_error')})
              setIsLoading(false);
          }
        } else {
          setCommonAlert({ open: true, msg: t('in_demo_mobile_login')})
          setIsLoading(false);
      }
        }
      }else{
        setCommonAlert({ open: true, msg: t('contact_input_error')})
        setIsLoading(false);
      }
    }else{
      setCommonAlert({ open: true, msg: t('country_blank_error')})
      setIsLoading(false);
    }
  }


  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if(data.otp && data.otp.length === 6){
      if(settings.customMobileOTP){
        let formattedNum = data.contact.replace(/ /g, '');
        const phoneNumber = "+" + data.country + formattedNum;
        dispatch(verifyMobileOtp(
          phoneNumber,
          data.otp
        ));
      } else{
        await dispatch(mobileSignIn(
          data.verificationId,
          data.otp
        ));
      }
      setIsLoading(false);
    }else{
      setCommonAlert({ open: true, msg: t('otp_validate_error')})
      setIsLoading(false);
    }
  }

  const handleCancel = (e) => {
    setData({
      ...data,
      contact: null,
      verificationId: null
    });
    setIsLoading(false);
  }

  const onCountryChange = (object, value) => {
    if (value && value.phone) {
      setData((prev) => ({ ...prev, country: value.phone, selectedcountry: value }));
      setMobileWithoutCountry("")
    }
  };

  const forgotPassword = async (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!re.test(data.contact)) {
      setCommonAlert({ open: true, msg: t('proper_email') });
      return;
    }
    // Un solo envío: cada correo nuevo invalida el enlace anterior.
    if (forgotBusyRef.current) return;
    forgotBusyRef.current = true;
    try {
      const result = await dispatch(sendResetMail(data.contact));
      if (result && result.success === false) {
        setCommonAlert({
          open: true,
          msg: t('not_registred') || 'No se pudo enviar el correo. Verifica el email e inténtalo de nuevo.',
        });
      } else {
        setCommonAlert({
          open: true,
          msg: t('email_send') || 'Te enviamos un enlace. Usa el correo más reciente y ábrelo una sola vez.',
        });
      }
    } finally {
      forgotBusyRef.current = false;
    }
  };

  const handleShowSignup = ()=>{
    setData({...data, email:"", firstName:"", lastName:"", password:"", confirmpassword:"",usertype:"customer",referralId:refer})
    setMobileWithoutCountry("")
    setShowSignUp(!showSignUp)
  }

  const mobileInputChange = (e)=>{
    const val = e.target.value;
    setMobileWithoutCountry(val)
    const formattedNum = val.replace(/ /g, '');
    setData((prev) => ({ ...prev, mobile: "+" + prev.country + formattedNum }))
  }

  const handleChangeUser = (event) => {
    const usertype = event.target.value;
    setData({
      ...data,
      usertype,
      cityId: '',
      cityName: '',
      referralId: '',
    });
  };
  const checkPasswordValidity = value => {
    if (value !== data.confirmpassword){
        return(t('confirm_password_not_match_err'));
    }
  
    const isNonWhiteSpace = /^\S*$/;
    if (!isNonWhiteSpace.test(value)) {
    return(t('password_must_not_contain_whitespaces'));
    }
  
    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(value)) {
    return(t('password_must_have_at_least_one_uppercase_character'));
    }
  
    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(value)) {
    return(t('password_must_have_at_least_one_lowercase_character'));
    }
  
    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(value)) {
    return(t('password_must_contain_at_least_one_digit'));
    }
  
    const isValidLength = /^.{8,16}$/;
    if (!isValidLength.test(value)) {
    return(t('password_must_be_8-16_characters_long'));
    }
  
    return null;
  }

  const validateMobile = () => {
    let mobileValid = true;
    if (mobileWithoutCountry.length < 6) {
        mobileValid = false;
        setCommonAlert({open:true, msg:t('mobile_no_blank_error')})
    }
    return mobileValid;
}


  const handleSignUp = (e)=>{
    e.preventDefault();
    new Promise(async (resolve,reject) => {
    setIsLoading(true)
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const validatePassword = checkPasswordValidity(data.password);
    if(re.test(data.email)){
      if (/\S/.test(data.firstName) && data.firstName.length > 0 && /\S/.test(data.lastName) && data.lastName.length > 0){
          if(!validatePassword){
            if (validateMobile()) {
              const userData = { ...data };
              if (userData.usertype === 'customer') delete userData.carType
                delete userData.confirmpassword;
                delete userData.pass;
                if (!userData.cityId) {
                  setCommonAlert({open:true, msg: signupError('city_required')})
                  setIsLoading(false);
                  reject();
                  return;
                }
                const city = citiesForRole.find((c) => c.id === userData.cityId);
                const slotsFull = !!(
                  userData.usertype === 'driver' &&
                  city &&
                  ((city.slotsUsed || 0) >= (city.slotsTotal || 100) || city.slotsFull)
                );
                if (city) userData.cityName = city.name;
                const refCode = userData.referralId ? normalizeSignupCode(userData.referralId) : '';
                const entryCode = refCode;
                if (userData.usertype === 'driver' && userData.cityId && !slotsFull && !refCode) {
                  setCommonAlert({open:true, msg: signupError('city_code_required')})
                  setIsLoading(false);
                  reject();
                  return;
                }
                if (userData.usertype === 'driver' && slotsFull && !refCode) {
                  setCommonAlert({open:true, msg: signupError('referral_code_required')})
                  setIsLoading(false);
                  reject();
                  return;
                }
                try {
                  const res = await checkUserExists(userData);
                  if(res.users && res.users.length > 0){
                    setCommonAlert({open:true, msg:t('user_exists')})
                    setIsLoading(false);
                    reject();
                    return;
                  }
                  delete userData.country;
                  let signupRes;

                  if (refCode.length > 0) {
                    const referralInfo = await validateReferer(refCode);
                    if (referralInfo?.uid) {
                      if (
                        userData.usertype === 'driver' &&
                        referralInfo.inNetwork &&
                        !referralInfo.isMasterReferrer &&
                        referralInfo.canRefer === false
                      ) {
                        setCommonAlert({
                          open: true,
                          msg: signupError(
                            referralInfo.networkLevel >= 3
                              ? 'network_level_cannot_refer'
                              : 'network_slots_full'
                          ),
                        })
                        setIsLoading(false);
                        reject();
                        return;
                      }
                      signupRes = await mainSignUp({
                        ...userData,
                        signupViaReferral: referralInfo.uid,
                        signupEntryCode: entryCode,
                        signupMode: 'normal',
                      });
                    } else if (userData.usertype === 'driver' && userData.cityId && !slotsFull) {
                      const cityCheck = await validateCityCodeClient(refCode, userData.cityId);
                      if (!cityCheck?.ok) {
                        setCommonAlert({open:true, msg: networkSignupErrorMessage(cityCheck?.error, t, 'signup_err_invalid_code')})
                        setIsLoading(false);
                        reject();
                        return;
                      }
                      signupRes = await mainSignUp({
                        ...userData,
                        citySignupCode: entryCode,
                        signupEntryCode: entryCode,
                        signupMode: 'city_special',
                        referralId: '',
                      });
                    } else {
                      if (looksLikeCityZoningCode(refCode) && userData.usertype !== 'driver') {
                        setCommonAlert({open:true, msg: signupError('city_code_needs_driver')})
                      } else if (looksLikeCityZoningCode(refCode) && userData.usertype === 'driver' && !userData.cityId) {
                        setCommonAlert({open:true, msg: signupError('city_code_needs_city')})
                      } else if (looksLikeCityZoningCode(refCode) && userData.usertype === 'driver' && slotsFull) {
                        setCommonAlert({open:true, msg: signupError('slots_full')})
                      } else if (looksLikeCityZoningCode(refCode) && userData.usertype === 'driver' && userData.cityId) {
                        setCommonAlert({open:true, msg: signupError('city_code_needs_city')})
                      } else {
                        setCommonAlert({open:true, msg:t('referer_not_found')})
                      }
                      setIsLoading(false);
                      reject();
                      return;
                    }
                  } else if (userData.usertype === 'driver' && userData.cityId && !slotsFull) {
                    setCommonAlert({open:true, msg: signupError('city_code_required')})
                    setIsLoading(false);
                    reject();
                    return;
                  } else {
                    signupRes = await mainSignUp({
                      ...userData,
                      signupMode: 'normal',
                      signupEntryCode: entryCode || ' ',
                    });
                  }
                  if(signupRes.uid){
                    const registeredAsCustomer = userData.usertype !== 'driver';
                    const cityOk =
                      typeof isCityOperationalForDrivers === 'function'
                        ? isCityOperationalForDrivers(zonificacionCities, {
                            cityId: userData.cityId,
                            cityName: userData.cityName,
                          })
                        : true;
                    setCityComingSoon(
                      !!(registeredAsCustomer && userData.cityId && !cityOk)
                    );
                    setData({...data, email:"", firstName:"", lastName:"", password:"", confirmpassword:"",usertype:"customer",referralId:"", cityId:"", cityName:""})
                    setMobileWithoutCountry("")
                    setMessage(true)
                    setIsLoading(false);
                    resolve();
                  }else{
                    setCommonAlert({open:true, msg: signupError(signupRes.error)})
                    setIsLoading(false);
                    reject();
                  }
                } catch (error) {
                  setCommonAlert({open:true, msg:t('reg_error')})
                  setIsLoading(false);
                  reject();
                }
            }else{
              setCommonAlert({open:true, msg:t('mobile_no_blank_error')})
              reject();
            }
          }else{
            setCommonAlert({open:true, msg:validatePassword})
            reject();
          }
      }else{
        setCommonAlert({open:true, msg:t('proper_input_name')})
        reject();
      }
    }else{
      setCommonAlert({open:true, msg:t('proper_email')})
      reject();
    }
  }).catch(()=>{})
  .finally(()=>{setIsLoading(false)})
  }

  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{ backgroundImage: `url(${loginBg})` }}
      >
        {showSignUp ? (
          <div className={classes.containerWide}>
            <div className={classes.glassCard}>
              <div className={classes.logoWrap}>
                <div className={classes.logoBadge}>
                  <img src={loginLogo} alt="Conecta2" className={classes.logoImg} />
                </div>
              </div>
              <form className={classes.form}>
                <h1 className={classes.signupTitle}>{t('signup')}</h1>
                <p className={classes.signupSubtitle}>
                  Crea tu cuenta Conecta2 en unos minutos
                </p>
                <CardBody style={{ padding: 0 }}>
                  <div className={classes.signupGrid}>
                    <fieldset className={classes.signupSection}>
                      <legend className={classes.signupSectionTitle}>Tus datos</legend>
                      <div className={classes.glassField}>
                        <input
                          className={classes.glassInput}
                          id="firstName"
                          type="text"
                          autoComplete="given-name"
                          required
                          placeholder="Nombre"
                          onChange={onInputChange}
                          value={data.firstName || ''}
                        />
                        <AccountBoxIcon className={classes.glassFieldIcon} />
                      </div>
                      <div className={classes.glassField}>
                        <input
                          className={classes.glassInput}
                          id="lastName"
                          type="text"
                          autoComplete="family-name"
                          required
                          placeholder="Apellido"
                          onChange={onInputChange}
                          value={data.lastName || ''}
                        />
                        <AccountBoxIcon className={classes.glassFieldIcon} />
                      </div>
                    </fieldset>

                    <fieldset className={classes.signupSection}>
                      <legend className={classes.signupSectionTitle}>Contacto</legend>
                      <div className={classes.glassField}>
                        <select
                          className={classes.glassSelect}
                          id="selectedcountry"
                          aria-label={t('select_country')}
                          disabled={!!data.verificationId || !settings?.AllowCountrySelection}
                          value={data.selectedcountry?.label || ''}
                          onChange={(e) => {
                            const country = (countries || []).find((c) => c.label === e.target.value);
                            if (country) onCountryChange(null, country);
                          }}
                        >
                          {(countries || []).map((c) => (
                            <option key={c.code || c.label} value={c.label}>
                              {c.label} +{c.phone}
                            </option>
                          ))}
                        </select>
                        <PublicIcon className={classes.glassFieldIcon} />
                      </div>
                      <div className={classes.glassField}>
                        <input
                          className={classes.glassInput}
                          id="mobileWithoutCountry"
                          type="tel"
                          autoComplete="tel-national"
                          required
                          placeholder="Teléfono"
                          onChange={mobileInputChange}
                          value={mobileWithoutCountry || ''}
                        />
                        <LocalPhoneIcon className={classes.glassFieldIcon} />
                      </div>
                    </fieldset>

                    <fieldset className={classes.signupSection}>
                      <legend className={classes.signupSectionTitle}>Perfil</legend>
                      <div className={classes.glassField}>
                        <select
                          className={classes.glassSelect}
                          id="usertype"
                          aria-label={t('User Type')}
                          value={data.usertype || 'customer'}
                          onChange={handleChangeUser}
                        >
                          <option value="customer">{t('customer')}</option>
                          <option value="driver">{t('driver')}</option>
                        </select>
                        <AccountBoxIcon className={classes.glassFieldIcon} />
                      </div>
                      <div className={classes.glassField}>
                        <select
                          className={classes.glassSelect}
                          id="cityId"
                          aria-label="Ciudad"
                          required
                          disabled={isDriverSignup && citiesForRole.length === 0}
                          value={data.cityId || ''}
                          onChange={(e) => {
                            const cityId = e.target.value;
                            const city = citiesForRole.find((c) => c.id === cityId);
                            setData({
                              ...data,
                              cityId,
                              cityName: city?.name || '',
                              referralId: data.usertype === 'driver' ? '' : data.referralId,
                            });
                          }}
                        >
                          <option value="" disabled>
                            {isDriverSignup && citiesForRole.length === 0
                              ? t('no_cities_configured')
                              : 'Selecciona tu ciudad'}
                          </option>
                          {citiesForRole
                            .slice()
                            .sort((a, b) =>
                              String(a.name || '').localeCompare(String(b.name || ''), 'es')
                            )
                            .map((c) => (
                              <option key={c.id} value={c.id}>
                                {customerCityLabel
                                  ? customerCityLabel(c)
                                  : c.department
                                  ? `${c.name} (${c.department})`
                                  : c.name}
                              </option>
                            ))}
                        </select>
                        <LocationOnIcon className={classes.glassFieldIcon} />
                      </div>
                      {isDriverSignup && citiesForRole.length === 0 ? (
                        <p className={`${classes.signupHint} ${classes.signupHintError}`}>
                          {t('admin_must_create_cities')}
                        </p>
                      ) : data.usertype === 'driver' && data.cityId ? (
                        <p className={classes.signupHint}>
                          {citySlotsFull ? t('city_slots_full_hint') : t('city_slots_open_hint')}
                        </p>
                      ) : null}
                    </fieldset>

                    <fieldset className={classes.signupSection}>
                      <legend className={classes.signupSectionTitle}>Acceso</legend>
                      <div className={`${classes.glassField} ${classes.signupFieldFull}`}>
                        <input
                          className={classes.glassInput}
                          id="email"
                          type="email"
                          autoComplete="email"
                          required
                          placeholder="Correo electrónico"
                          onChange={onInputChange}
                          value={data.email || ''}
                        />
                        <EmailIcon className={classes.glassFieldIcon} />
                      </div>
                      <div className={classes.glassField}>
                        <input
                          className={classes.glassInput}
                          id="password"
                          type={showPassword ? 'password' : 'text'}
                          autoComplete="new-password"
                          required
                          placeholder="Contraseña"
                          onChange={onInputChange}
                          value={data.password || ''}
                        />
                        <button
                          type="button"
                          className={classes.eyeBtn}
                          onClick={() => setShowPassword(!showPassword)}
                          aria-label="toggle password"
                        >
                          {showPassword ? (
                            <VisibilityOffIcon sx={{ fontSize: 22 }} />
                          ) : (
                            <VisibilityIcon sx={{ fontSize: 22 }} />
                          )}
                        </button>
                      </div>
                      <div className={classes.glassField}>
                        <input
                          className={classes.glassInput}
                          id="confirmpassword"
                          type={showConfirmPassword ? 'password' : 'text'}
                          autoComplete="new-password"
                          required
                          placeholder="Confirmar contraseña"
                          onChange={onInputChange}
                          value={data.confirmpassword || ''}
                        />
                        <button
                          type="button"
                          className={classes.eyeBtn}
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          aria-label="toggle confirm password"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOffIcon sx={{ fontSize: 22 }} />
                          ) : (
                            <VisibilityIcon sx={{ fontSize: 22 }} />
                          )}
                        </button>
                      </div>
                    </fieldset>

                    <fieldset className={classes.signupSection}>
                      <legend className={classes.signupSectionTitle}>Invitación</legend>
                      <div className={`${classes.glassField} ${classes.signupFieldFull}`}>
                        <input
                          className={classes.glassInput}
                          id="referralId"
                          type="text"
                          autoComplete="off"
                          placeholder={
                            data.usertype === 'driver'
                              ? citySlotsFull
                                ? t('inviter_code_optional')
                                : data.cityId
                                ? t('zoning_code_placeholder')
                                : t('select_city_first')
                              : 'Código de quien te invitó (opcional)'
                          }
                          onChange={onInputChange}
                          value={data.referralId || ''}
                        />
                        <AccountBoxIcon className={classes.glassFieldIcon} />
                      </div>
                    </fieldset>
                  </div>
                </CardBody>
                <CardFooter className={classes.cardFooter}>
                  {message ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'center' }}>
                      <Typography style={{ color: colors.GREEN, fontWeight: 'bold' }}>
                        {t('account_create_successfully')}
                      </Typography>
                      {cityComingSoon ? (
                        <Typography
                          style={{
                            color: '#FFDE59',
                            fontWeight: 600,
                            textAlign: 'center',
                            maxWidth: 320,
                          }}
                        >
                          {t('city_coming_soon_operational') ||
                            'Pronto estaremos operativos en esta ciudad.'}
                        </Typography>
                      ) : null}
                      <button
                        type="button"
                        className={classes.loginBtn}
                        onClick={() => {
                          setCityComingSoon(false);
                          setShowSignUp(false);
                        }}
                      >
                        <span style={{ position: 'relative', zIndex: 1 }}>{t('signIn')}</span>
                      </button>
                    </div>
                  ) : isLoading ? (
                    <DialogActions style={{ justifyContent: 'center' }}>
                      <CircularProgress sx={{ color: '#7628FF' }} />
                    </DialogActions>
                  ) : (
                    <>
                      <button type="submit" className={classes.loginBtn} onClick={handleSignUp}>
                        <span style={{ position: 'relative', zIndex: 1 }}>{t('signup')}</span>
                        <span className={classes.loginBtnArrow}>
                          <ArrowForwardIcon sx={{ fontSize: 18 }} />
                        </span>
                      </button>
                      <button type="button" className={classes.secondaryBtn} onClick={handleShowSignup}>
                        {t('login')}
                      </button>
                    </>
                  )}
                </CardFooter>
              </form>
            </div>
          </div>
        ) : (
          <>
            <div id="sign-in-button" />
            <div className={classes.container}>
              <div className={classes.glassCard}>
                <div className={classes.logoWrap}>
                  <div className={classes.logoBadge}>
                    <img src={loginLogo} alt="Conecta2" className={classes.logoImg} />
                  </div>
                </div>

                <form className={classes.form} onSubmit={(e) => e.preventDefault()}>
                  {data.selectedcountry && settings?.mobileLogin && countries && countries.length > 0 ? (
                    <div className={classes.countryWrap}>
                      <CountrySelect
                        countries={countries}
                        label={t('select_country')}
                        value={data.selectedcountry}
                        onChange={onCountryChange}
                        style={{ paddingTop: 8 }}
                        disabled={data.verificationId ? true : false}
                        readOnly={!settings.AllowCountrySelection}
                      />
                    </div>
                  ) : null}

                  <div className={classes.glassField}>
                    <EmailOutlinedIcon className={classes.glassFieldIcon} />
                    <input
                      className={classes.glassInput}
                      id="contact"
                      type="text"
                      autoComplete="username"
                      disabled={!!data.verificationId}
                      placeholder={
                        settings?.emailLogin && settings?.mobileLogin
                          ? t('contact_placeholder')
                          : settings?.emailLogin && !settings?.mobileLogin
                          ? t('email_id')
                          : t('mobile_number')
                      }
                      onChange={onInputChange}
                      value={data.contact || ''}
                    />
                  </div>

                  {(data.contact && isNaN(data.contact)) ||
                  (settings?.emailLogin && !settings?.mobileLogin) ? (
                    <div className={classes.glassField}>
                      <LockOutlinedIcon className={classes.glassFieldIcon} />
                      <input
                        className={classes.glassInput}
                        id="otp"
                        type={showPassword ? 'password' : 'text'}
                        autoComplete="current-password"
                        placeholder={t('password')}
                        onChange={onInputChange}
                        value={data.otp || ''}
                      />
                      <button
                        type="button"
                        className={classes.eyeBtn}
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label="toggle password"
                      >
                        {showPassword ? (
                          <VisibilityOffIcon sx={{ fontSize: 22 }} />
                        ) : (
                          <VisibilityIcon sx={{ fontSize: 22 }} />
                        )}
                      </button>
                    </div>
                  ) : null}

                  {data.verificationId ? (
                    <div className={classes.glassField}>
                      <LockOutlinedIcon className={classes.glassFieldIcon} />
                      <input
                        className={classes.glassInput}
                        id="otp"
                        type="password"
                        autoComplete="one-time-code"
                        placeholder={t('otp')}
                        onChange={onInputChange}
                        value={data.otp || ''}
                      />
                    </div>
                  ) : null}

                  {isLoading ? (
                    <div className={classes.loadingWrap}>
                      <CircularProgress sx={{ color: '#7628FF' }} />
                    </div>
                  ) : !data.verificationId ? (
                    <>
                      <button type="button" className={classes.loginBtn} onClick={handleGetOTP}>
                        <span style={{ position: 'relative', zIndex: 1 }}>
                          {settings?.mobileLogin
                            ? data.contact && isNaN(data.contact)
                              ? 'INICIAR SESIÓN'
                              : t('login_otp')
                            : 'INICIAR SESIÓN'}
                        </span>
                        <span className={classes.loginBtnArrow}>
                          <ArrowForwardIcon sx={{ fontSize: 18 }} />
                        </span>
                      </button>
                      {data.contact && isNaN(data.contact) ? (
                        <button
                          type="button"
                          className={classes.forgotLink}
                          onClick={() => forgotPassword()}
                        >
                          {t('forgot_password')}
                        </button>
                      ) : null}
                    </>
                  ) : (
                    <>
                      <button type="button" className={classes.loginBtn} onClick={handleVerifyOTP}>
                        <span style={{ position: 'relative', zIndex: 1 }}>{t('verify_otp')}</span>
                        <span className={classes.loginBtnArrow}>
                          <ArrowForwardIcon sx={{ fontSize: 18 }} />
                        </span>
                      </button>
                      <button type="button" className={classes.secondaryBtn} onClick={handleCancel}>
                        {t('cancel')}
                      </button>
                    </>
                  )}

                  {(settings?.socialLogin !== false) ? (
                    <>
                      <div className={classes.dividerRow}>
                        <div className={classes.dividerLine} />
                        <div className={classes.dividerDot} />
                        <div className={classes.dividerLine} />
                      </div>
                      <div className={classes.socialRow}>
                        <button
                          type="button"
                          className={classes.socialBtn}
                          onClick={() => loginWithGoogle()}
                          aria-label="Google"
                        >
                          <svg
                            className={classes.socialGoogleIcon}
                            viewBox="0 0 48 48"
                            width="28"
                            height="28"
                            aria-hidden="true"
                            focusable="false"
                          >
                            <path
                              fill="#FFC107"
                              d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.227 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
                            />
                            <path
                              fill="#FF3D00"
                              d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
                            />
                            <path
                              fill="#4CAF50"
                              d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
                            />
                            <path
                              fill="#1976D2"
                              d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          className={classes.socialBtn}
                          onClick={() =>
                            setCommonAlert({
                              open: true,
                              msg: 'El acceso con Apple está disponible en la app móvil.',
                            })
                          }
                          aria-label="Apple"
                        >
                          <AppleIcon sx={{ color: '#FBFAFE', fontSize: 28 }} />
                        </button>
                      </div>
                    </>
                  ) : null}
                </form>

                {!isLoading ? (
                  <div className={classes.registerRow}>
                    ¿No tienes una cuenta?
                    <button type="button" className={classes.registerLink} onClick={handleShowSignup}>
                      Registrarse
                    </button>
                  </div>
                ) : null}

                {!settings?.AllowCriticalEditsAdmin ? (
                  <div className={classes.demoCard}>
                    <div>
                      {t('Email Id')} : support@exicube.com
                    </div>
                    <div>
                      {t('Password')} : Admin@123
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </>
        )}
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
      </div>
    </div>
  );
}
